import React, { Component } from 'react';
// import { Table } from '../basic';
import { Table2D } from '../basic';

import env from '../../helpers/env';
let Table = null;
//FLH2D Move 2D Table To YXYWeb
export default class TableContainer extends Component {
  constructor(props) {
    super(props);
    Table = env.INTERACTIVE_MODE === 'touch' ? require('../grid-touch').default : require('../basic/table').default;
    const { meta, viewModel } = props;
    const { controls, cGroupCode, containers, childrenField, cCode } = meta;
    const actions = containers && containers.length ? containers[0] : null;
    if (actions && actions.controls) {
      actions.controls.forEach(item => {
        if (!item.cParameter) return;
        try {
          const config = JSON.parse(item.cParameter);
          config.model = viewModel.get(item.cItemName);
          Object.assign(item, config);
        } catch (e) {

        }
      });
    }
    const columns = {};
    const { billNo } = viewModel.getParams();
    if (controls) {

      controls.forEach(column => {
        const { cItemName, cStyle } = column;
        column.index = `${billNo}|${cGroupCode}|${cItemName}`;
        columns[cItemName] = column;
        if (!cStyle || !actions || !actions.controls) return;
        try {
          const { related } = JSON.parse(cStyle);
          if (!related) return;
          const relatedActions = [];
          if (cb.utils.isArray(related)) {
            related.forEach(field => {
              const actionIndex = actions.controls.findIndex(item => {
                return item.cItemName === field;
              });
              if (actionIndex === -1) return;
              relatedActions.push(actions.controls[actionIndex]);
              actions.controls.splice(actionIndex, 1);
            });
          } else {
            const actionIndex = actions.controls.findIndex(item => {
              return item.cItemName === related;
            });
            if (actionIndex === -1) return;
            relatedActions.push(actions.controls[actionIndex]);
            actions.controls.splice(actionIndex, 1);
          }
          column.relatedActions = relatedActions;
        } catch (e) {

        }
      })
    }
    const controlModel = viewModel.get(childrenField || cCode);
    if (controlModel) {
      controlModel.setCache('actions', actions && actions.controls || []);
      controlModel.setCache('groupCode', cGroupCode);
      if (env.INTERACTIVE_MODE === 'touch')
        controlModel.setState('override', false);
    } else {
      cb.utils.alert('元数据配置有误', 'error');
    }
    this.state = {
      controlModel,
      columns,
      actions,
      height: props.height || document.body.clientHeight
    };
    this.listHeaderHeight = 0;
    props.viewModel.on('listHeaderHeightUpdate', (height, filterName) => {
      const { multipleFilters } = this.props.viewModel.getParams();
      const modelFilterName = controlModel.getState('filterName');
      if (multipleFilters && !modelFilterName || modelFilterName && filterName !== modelFilterName) return;
      this.listHeaderHeight = height;
      this.setState({ height: (this.props.height || document.body.clientHeight) - height });
    });
    this.setTable2DInfo(billNo, viewModel, props, controlModel);
  }

  setTable2DInfo = (billNo, viewModel, props, controlModel) => {
    let self = this;
    let config;
    self.state.support2D = false;//是否支持二维表
    self.state.show2D = false;//打开界面时先进入一维表还是二维表
    self.state.className2D = (billNo ? "TableContainer_Outer_" + billNo : "");
    try {
      config = props.config && JSON.parse(props.config);
      if (config) {
        if (config.className2D)
          self.state.className2D = config.className2D;
        if (config.support2D == "true" || config.support2D == true)
          self.state.support2D = true;
        if (config.show2D == "true" || config.show2D == true)
          self.state.show2D = true;
      }
      if (self.state.support2D) {
        controlModel.setCache("T2DKey_Bus", "T2DKey_Bus_" + (controlModel.getName() || "") + "_" + Math.floor(Math.random() * 100000));
        controlModel.setCache("T2D_TableNum", "1D");
        controlModel.t2DInfo_Bus_Set("support2D", true);
        controlModel.t2DInfo_Bus_Set("show2D", self.state.show2D);
        self.setBtnClassName(viewModel, self.state.show2D);
        viewModel.on('table2DBtnClick', () => {
          let value = !self.state.show2D
          controlModel.t2DInfo_Bus_Set("show2D", value);
          self.setState({ show2D: value });
          self.setBtnClassName(viewModel, value);
        });
      }
    }
    catch (e) { }
  }


  setBtnClassName = (viewModel, value) => {
    let btnModel = viewModel.get("btnTable2D");
    let classname = value ? "BtnTable2D_Selected" : "BtnTable2D_UnSelected"
    btnModel && btnModel.setState("T2DClassName", classname)
  }
  recalcTableHeight = (substractHeight, key) => {
    const { parents } = this.props;
    if (parents && parents.key === key)
      this.setState({ substractHeight });
  }
  componentDidMount() {
    // const { multipleFilters } = this.props.viewModel.getParams();
    // const modelFilterName = this.state.controlModel.getState('filterName');
    // this.props.viewModel.on('listHeaderHeightUpdate', (height, filterName) => {
    //   if (multipleFilters && !modelFilterName || modelFilterName && filterName !== modelFilterName) return;
    //   this.setState({ height: (this.props.height || document.body.clientHeight) - height, listHeaderHeight: height });
    // });
    this.props.viewModel.on('recalcTableHeight', this.recalcTableHeight);
  }
  componentWillUnmount() {
    this.props.viewModel.un('recalcTableHeight', this.recalcTableHeight);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.height != nextProps.height) {
      this.setState({ height: nextProps.height - this.listHeaderHeight });
    }
  }
  getTableWidth = (style, width) => {
    let tableWidth = width;
    // 当用户传width以用户传的为主，如果没有传width但是传入diffWidth属性，则宽度 = 容器width - 差额宽度值，如果width和diffWidth都没有值时则为传入的宽度值
    if (style.outerSubstractWidth)
      tableWidth -= style.outerSubstractWidth;
    if (style.width) {
      tableWidth = style.width
    } else if (style.diffWidth) {//diffWidth为当前表格宽度差额值。
      tableWidth = tableWidth - style.diffWidth
    } else if (style.widthPercent) {
      tableWidth = tableWidth * style.widthPercent - (style.substractWidth || 0);
    }
    return tableWidth;
  }
  getTableHeight = (style, height) => {
    let tableHeight = height;
    if (style.substractHeight) {
      tableHeight = tableHeight - style.substractHeight;
    } else if (this.state.substractHeight) {
      tableHeight = tableHeight - this.state.substractHeight;
    } else if (style.fixedHeight) {
      tableHeight = style.fixedHeight;
    }
    if (!cb.utils.isEmpty(style.heightPercent))
      tableHeight = tableHeight * parseFloat(style.heightPercent) / 100;
    return tableHeight;
  }
  getBCalcHeight = () => {
    if (this.listHeaderHeight || this.containersHeight || this.cardHeaderHeight || this.footerHeight)
      return true
    else
      return false
  }
  render() {
    const { meta, width, viewModel, extraProps } = this.props;
    const style = meta.cStyle ? JSON.parse(meta.cStyle) : {};
    let tableWidth = this.getTableWidth(style, width);
    const { controlModel, columns, actions, height } = this.state;
    let tableHeight = this.getTableHeight(style, height);
    const bCalcHeight = this.getBCalcHeight();
    const extraConfig = {};
    if (style.substractHeight || this.state.substractHeight || style.fixedHeight) extraConfig.autoHeight = false;
    if ( extraProps && (extraProps.cBillType == 'voucher' || extraProps.cBillType == 'archive')) extraConfig.adaptiveHeight = true;
    if (this.state.support2D) {
      return (
        <div className={"TableContainer_Outer " + (this.state.className2D ? this.state.className2D : "")}>
          <div
            className="TableContainer_2D"
            style={{ display: (this.state.show2D ? '' : 'none') }}
          >
            <Table2D
              viewModel={viewModel}
              show2D={this.state.show2D}
              config2D={this.props.config}
              width={tableWidth}
              height={tableHeight}
              actions={actions}
              bCalcHeight={bCalcHeight}
            />
          </div>
          <div
            className="TableContainer_1D"
            style={{ display: (this.state.show2D ? 'none' : '') }}
          >
            <Table
              T2D_TableNum={"1D"}
              width={tableWidth}
              height={tableHeight}
              bCalcHeight={bCalcHeight}
              code={meta.cGroupCode}
              viewModel={viewModel}
              action={actions}
              columns={columns}
              style={style}
              model={controlModel}
              meta={this.props.meta}
              {...extraConfig}
            />
          </div>
        </div>
      );
    }
    else {
      return (
        <Table
          width={tableWidth}
          height={tableHeight}
          listHeaderHeight={this.listHeaderHeight}
          code={meta.cGroupCode}
          action={actions}
          columns={columns}
          style={style}
          model={controlModel}
          meta={this.props.meta}
          {...extraConfig}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/TableContainer.jsx